export const DEFAULT_THEME_COLOR = '#f9fafb'
